
import { prop, Vue } from "vue-class-component";

class Props {
  status = prop<boolean>({
    default: false,
    type: Boolean
  });
}
export default class InputManifestDashboard extends Vue.with(Props) {}
